import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-sidenave-no-header-layout',
  templateUrl: './no-sidenave-no-header-layout.component.html',
  styleUrls: ['./no-sidenave-no-header-layout.component.scss']
})
export class NoSidenaveNoHeaderLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
